import React, { Dispatch, useState } from 'react';
import { Button, Space, Tooltip } from 'antd';
import { Props } from './types';
import { Container, ContButton, ListAttachments } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { sendMenssageRequest } from '../../../../../../store/ducks/sendMenssages/actions';
import { SendOutlined, PaperClipOutlined, DeleteTwoTone } from '@ant-design/icons';
// import { loadRequest } from '../../../../../../store/ducks/ocorrencia/actions';
import Upload from './Upload';
import { colorIconConversation } from '../../../../Utils';
import { ApplicationState } from '../../../../../../store';

const FormComponent: React.FC<Props> = ({ protocolo, status }) => {
  const [hashAttachment, setHashAttachment] = useState<any>([]);
  const [textAreaValue, setTextAreaValue] = React.useState<string>('');
  const dispatch = useDispatch<Dispatch<any>>();

  const ocorrencia = useSelector(
    (state: ApplicationState) => state?.Ocorrencia?.data['ocorrencia']
  );

  const sendMessage = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    dispatch(sendMenssageRequest(protocolo, textAreaValue, hashAttachment));
    setTextAreaValue('');
    setHashAttachment([]);
  };

  const handleDeleteFile = (filekey: string): void => {
    hashAttachment.forEach((file: any) => {
      if (file.key === filekey) {
        const index = hashAttachment.indexOf(file);
        hashAttachment.splice(index, 1);
        setHashAttachment([...hashAttachment]);
      }
    });
  };

  const color = colorIconConversation(ocorrencia?.urgencia);

  return (
    <Container>
      <Tooltip
        title={
          status === 'AC'
            ? 'Desculpe o status atual do atendimento não permite enviar mensagens'
            : ''
        }
      >
        <form onSubmit={sendMessage}>
          <textarea
            placeholder="Digite aqui sua mensagem "
            name="formValue"
            id="formValue"
            data-testid="textbox"
            value={textAreaValue}
            onChange={(e) => setTextAreaValue(e.target.value)}
            className="textarea"
            rows={6}
            disabled={status === 'AC'}
          />
          <ListAttachments data-cy="listAttachments">
            {hashAttachment?.map((file: any) => (
              <li key={file?.key}>
                <Space>
                  <span className="icon deletAttachments">
                    <DeleteTwoTone
                      twoToneColor="red"
                      onClick={() => handleDeleteFile(file?.key)}
                      data-testid="btnDelete"
                    />
                  </span>
                  <span>
                    <PaperClipOutlined /> {file?.nome}
                  </span>
                </Space>
              </li>
            ))}
          </ListAttachments>

          <ContButton>
            <Upload
              hashAttachment={hashAttachment}
              setHashAttachment={setHashAttachment}
              data-testid="btnAttachment"
            />
            <Tooltip title={!textAreaValue ? 'Digite sua mensagem' : ''}>
              <Button
                type="primary"
                disabled={textAreaValue === '' || !textAreaValue.trim()}
                htmlType="submit"
                icon={
                  <SendOutlined
                    style={{
                      color: textAreaValue === '' || !textAreaValue.trim() ? color : 'inherit',
                    }}
                  />
                }
                data-testid="btnSend"
              >
                Enviar
              </Button>
            </Tooltip>
          </ContButton>
        </form>
      </Tooltip>
    </Container>
  );
};

export default FormComponent;
